// src/components/MakePaymentButton/MakePaymentButton.js
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify"; // Keep if using toasts anywhere
import "react-toastify/dist/ReactToastify.css";
import "./MakePaymentButton.css"; // Ensure CSS file exists
import { Link } from "react-router-dom";

const MakePaymentButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // --- Scroll Handler ---
  const handleScroll = () => {
    const scrollThreshold = 300; // Show button after scrolling 300px (adjust as needed)
    if (window.scrollY > scrollThreshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // --- Effect to Add/Remove Scroll Listener ---
  useEffect(() => {
    // Add listener when component mounts
    window.addEventListener("scroll", handleScroll);

    // Cleanup: Remove listener when component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures this runs only on mount and unmount

  // --- Click Handler to Scroll to the Booking Form ---
  const handleScrollToForm = (event) => {
    event.preventDefault(); // Prevent any default button behavior

    // Find the target booking form element by its ID
    const formSection = document.getElementById("booking-form-section");

    if (formSection) {
      // Use smooth scrolling to bring the form into view
      formSection.scrollIntoView({
          behavior: "smooth", // Enable smooth scrolling
          block: "start"      // Align the top of the form with the top of the viewport
      });
    } else {
      // Log a warning if the target form element cannot be found
      console.warn("Target element '#booking-form-section' not found for scrolling.");
    }
  };

  return (
    // Container div controls the visibility and positioning
    <div className={`fixed-button-container ${isVisible ? 'visible' : 'hidden'}`}>
      {/* ToastContainer if needed */}
      <ToastContainer position="top-right" autoClose={3000} />

     <Link to="https://cal.com/gfa-admin-fczjtr/30min">
      <button
        className="fixed-action-button" 
        
      >
        Book Your Free Call Now {/* Updated Button Text */}
      </button></Link>
    </div>
  );
};

export default MakePaymentButton;